import * as Api from "api";
import { SIGNOUT } from "constants/sessions";
import { networkAction } from "helpers/network/networkAction";

export const signout = () => async (dispatch) =>
  networkAction(dispatch, SIGNOUT, Api.signout, []);
